import { node } from "~/util/dom";

export function createHeader(settingName: string, title: string) {
	const header = node("div", { className: `settings-${settingName}__header` });

	header.appendChild(node("h3", { className: `settings-${settingName}__title`, innerHTML: title }));

	return header;
}
